import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'hi',
  months: ['जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर'],
  monthsShort: ['जन', 'फर', 'मार्च', 'अप्रै', 'मई', 'जून', 'जुला', 'अग', 'सितं', 'अक्टू', 'नवं', 'दिसं'],
  weekdays: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार'],
  weekdaysMin: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
  weekdaysShort: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरू', 'शुक्र', 'शनि'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s वर्ष पहले', other: '%s वर्ष पहले' },
    M: { one: '%s माह पहले', other: '%s माह पहले' },
    w: { one: '%s सप्ताह पहले', other: '%s सप्ताह पहले' },
    d: { one: '%s दिन पहले', other: '%s दिन पहले' },
    h: { one: '%s घं॰ पहले', other: '%s घं॰ पहले' },
    m: { one: '%s मि॰ पहले', other: '%s मि॰ पहले' },
    s: { one: '%s से॰ पहले', other: '%s से॰ पहले' },
  },
  future: {
    y: { one: '%s वर्ष में', other: '%s वर्ष में' },
    M: { one: '%s माह में', other: '%s माह में' },
    w: { one: '%s सप्ताह में', other: '%s सप्ताह में' },
    d: { one: '%s दिन में', other: '%s दिन में' },
    h: { one: '%s घं॰ में', other: '%s घं॰ में' },
    m: { one: '%s मि॰ में', other: '%s मि॰ में' },
    s: { one: '%s से॰ में', other: '%s से॰ में' },
  },
  pastLong: {
    y: { one: '%s वर्ष पहले', other: '%s वर्ष पहले' },
    M: { one: '%s माह पहले', other: '%s माह पहले' },
    w: { one: '%s सप्ताह पहले', other: '%s सप्ताह पहले' },
    d: { one: '%s दिन पहले', other: '%s दिन पहले' },
    h: { one: '%s घंटे पहले', other: '%s घंटे पहले' },
    m: { one: '%s मिनट पहले', other: '%s मिनट पहले' },
    s: { one: '%s सेकंड पहले', other: '%s सेकंड पहले' },
  },
  futureLong: {
    y: { one: '%s वर्ष में', other: '%s वर्ष में' },
    M: { one: '%s माह में', other: '%s माह में' },
    w: { one: '%s सप्ताह में', other: '%s सप्ताह में' },
    d: { one: '%s दिन में', other: '%s दिन में' },
    h: { one: '%s घंटे में', other: '%s घंटे में' },
    m: { one: '%s मिनट में', other: '%s मिनट में' },
    s: { one: '%s सेकंड में', other: '%s सेकंड में' },
  },
  abbr: {
    y: { one: '%sवर्ष', other: '%sवर्ष' },
    M: { one: '%sमहीना', other: '%sमहीने' },
    w: { one: '%sसप्ताह', other: '%sसप्ताह' },
    d: { one: '%sदिन', other: '%sदिन' },
    h: { one: '%sघं', other: '%sघं' },
    m: { one: '%sमिनट', other: '%sमिनट' },
    s: { one: '%sसेकंड', other: '%sसेकंड' },
  },
  full: {
    y: { one: '%s वर्ष', other: '%s वर्ष' },
    M: { one: '%s महीना', other: '%s महीने' },
    w: { one: '%s सप्ताह', other: '%s सप्ताह' },
    d: { one: '%s दिन', other: '%s दिन' },
    h: { one: '%s घंटा', other: '%s घंटे' },
    m: { one: '%s मिनट', other: '%s मिनट' },
    s: { one: '%s सेकंड', other: '%s सेकंड' },
  },
  justNow: 'बस अभी',
  yesterday: 'बीता कल',
  today: 'आज',
  tomorrow: 'कल',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'hi';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
